import { SecuritySettingsMfaStatusEnum, UpdateMfaStatusDocument } from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useUpdateMfaStatus() {
  const session = useCurrentSession()
  const [mutation, { loading }] = useMutation(UpdateMfaStatusDocument, {
    extractorFn: (data) => data.securitySettingsMutations.updateSecuritysettingsCompanyConfig,
  })

  const updateMfaStatus = useUnsafeCallback(
    (mfaStatus: SecuritySettingsMfaStatusEnum) => {
      return mutation({
        variables: {
          companyId: session.company.id,
          mfaStatus: mfaStatus,
        },
      })
    },
    [mutation, session.company.id]
  )

  return {
    updateMfaStatus,
    loading,
  }
}
